import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import axios from 'axios';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Podcast } from '../models/podcast.model';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class PodcastService {
  http = inject(HttpClient);
  utilsService = inject(UtilsService);
  constructor() {}

  async getPodcasts(uid: string): Promise<Observable<any>> {
    try {
      const baseParams = new HttpParams().set('uid', uid).set('limit', 3);
      return this.utilsService.setHttpHeaders(false).then((headers) => {
        return this.http.get(environment['AWS_PODCAST_FETCH']!, {
          params: baseParams,
          headers: headers,
        });
      });
    } catch (error) {
      console.error(`Error fetching podcasts: ${error}`);
      throw { message: `Error fetching podcasts: ${error}` };
    }
  }

  // async getPodcastUploadUrl(uuid: string, fileExtn: string): Promise<any> {
  //   return this.utilsService
  //     .setAxiosHeaders(true)
  //     .then((headers) => {
  //       headers = { ...headers, 'Content-Type': `podcast/${fileExtn}` };
  //       return axios.get<any>(environment['AWS_PODCAST_SIGNEDURL']!, {
  //         params: { id: uuid, fileExtn: fileExtn },
  //         headers: headers,
  //       });
  //     })
  //     .then((response) => {
  //       return {
  //         method: 'PUT',
  //         url: response.data.url,
  //         headers: {
  //           'Content-Type': `podcast/${fileExtn}`,
  //         },
  //       };
  //     });
  // }

  // // Call AWS API to Initilize Multipart Podcast upload
  // async initializeMultipartUpload(): Promise<any> {
  //   return this.utilsService.setAxiosHeaders(true).then(async (headers) => {
  //     const response = await axios.post(
  //       environment['AWS_PODCAST_UPLOAD_INITIALIZE']!,
  //       {
  //         headers: headers,
  //       }
  //     );
  //     return response.data;
  //   });
  // }

  // // Call AWS API to get PreSigned URL for uploading Podcast Part
  // async getMultiPartPreSignedUrl(
  //   uploadId: string,
  //   key: string,
  //   partNumber: number
  // ): Promise<string> {
  //   return this.utilsService
  //     .setAxiosHeaders(true)
  //     .then((headers) => {
  //       return axios.get<any>(environment['AWS_PODCAST_UPLOAD_PART']!, {
  //         params: { uploadId: uploadId, key: key, partNumber: partNumber },
  //         headers: headers,
  //       });
  //     })
  //     .then((response) => response.data.url);
  // }

  // async listParts(uploadId: string, key: string): Promise<any> {
  //   return this.utilsService
  //     .setAxiosHeaders(true)
  //     .then((headers) => {
  //       return axios.get<any>(environment['AWS_PODCAST_UPLOAD_LIST_PARTS']!, {
  //         params: { uploadId: uploadId, key: key },
  //         headers: headers,
  //       });
  //     })
  //     .then((response) => response.data['Parts']);
  // }

  // async abortMultipartUpload(uploadId: string, key: string) {
  //   const headers = await this.utilsService.setAxiosHeaders(true);
  //   const response = await axios.delete<any>(
  //     environment['AWS_PODCAST_UPLOAD_ABORT']!,
  //     {
  //       params: { uploadId: uploadId, key: key },
  //       headers: headers,
  //     }
  //   );
  //   return response.data;
  // }

  // async completeMultipartUpload(uploadId: string, key: string, parts: any) {
  //   return this.utilsService.setAxiosHeaders(true).then(async (headers) => {
  //     const response = await axios.post(
  //       environment['AWS_PODCAST_UPLOAD_COMPLETE']!,
  //       {
  //         uploadId: uploadId,
  //         key: key,
  //         parts: parts,
  //         headers: headers,
  //       }
  //     );
  //     return response.data;
  //   });
  // }

  async create(podcast: Partial<Podcast>): Promise<any> {
    return this.utilsService.setAxiosHeaders(true).then(async (headers) => {
      // console.log('PodcastService:: create:', headers);
      return axios
        .put(environment['AWS_PODCAST_CREATE']!, podcast, { headers: headers })
        .catch((error) => {
          throw error;
        })
        .then((response) => {
          return response.data;
        });
    });
  }

  async update(podcast: Partial<Podcast>): Promise<Podcast> {
    return this.utilsService.setAxiosHeaders(true).then(async (headers) => {
      // console.log('PodcastService:: update:', headers);
      return axios
        .put(environment['AWS_PODCAST_UPDATE']!, podcast, { headers: headers })
        .catch((error) => {
          throw error;
        })
        .then((response) => {
          return response.data;
        });
    });
  }

  async delete(id: string): Promise<string> {
    return this.utilsService.setAxiosHeaders(true).then(async (headers) => {
      return axios
        .delete(environment['AWS_PODCAST_DELETE']!, {
          params: { id: id },
          headers: headers,
        })
        .catch((error) => {
          throw error;
        })
        .then((response) => {
          return id;
        });
    });
  }
}
